import React from 'react'

const CookieGroupsContext = React.createContext()

export default CookieGroupsContext
